import React, { useEffect, useRef, useState, useCallback } from "react";
import { ListSkeleton } from "../../skeletons/List";
import { AuthHelper } from "../../controllers/AuthHelper";
import FloatingActionButtons from "../../components/Fab";
import { Checkbox, IconButton, Box, Typography, Drawer } from "@mui/material";
import { Delete } from "@mui/icons-material";
import { register } from "swiper/element/bundle";
import TeacherForm from "../../components/TeacherForm";
import { ServerConfig } from "../../../connectors/Config";

register();


const SingleCourse = React.memo(({ course, certificates, assignCourseToTeacher, refreshTeachers, onEdit }) => (
  <div style={{ maxWidth: 400, minHeight: 800, padding: "0 120px 48px" }}>
    <h2 style={{ textAlign: "left" }}>{course["nome corso"]}</h2>
    <div>
      {certificates.map((teacher) => {
        const assigned = teacher.assignments?.some((x) => x.course === course["id"]);
        return (
          <div key={teacher.id} style={{ display: "flex", alignItems: "center", gap: 8 }}>
            <Checkbox checked={!!assigned} onChange={() => assignCourseToTeacher(course["id"], teacher.id)} />
            <h5 style={{ flex: 1, cursor: "pointer" }} onClick={() => onEdit(teacher)}>{teacher.name}</h5>
            <IconButton
              onClick={async () => {
                try {
                  await fetch(`${ServerConfig.AWS.Serverless.API_BASE_URL_2}/teachers/${teacher.id}`, { method: "DELETE" });
                  refreshTeachers();
                } catch { alert("Errore server"); }
              }}
            >
              <Delete color="error" />
            </IconButton>
          </div>
        );
      })}
    </div>
  </div>
));

const ListTeachers = () => {
  const [certificates, setCertificates] = useState([]);
  const [courses, setCourses] = useState([]);
  const [loading, setLoading] = useState(true);
  const [drawerOpen, setDrawerOpen] = useState(false);
  const [drawerTitle, setDrawerTitle] = useState("");
  const [drawerContent, setDrawerContent] = useState(null);
  const [currentUser, setCurrentUser] = useState("");
  const swiperRef = useRef(null);

  // Recupera l'utente loggato
  useEffect(() => {
    const fetchUser = async () => {
      const apiKey = localStorage.getItem("cruddy-apiKey");
      const user = await AuthHelper.getUserFromIdToken(apiKey);
      setCurrentUser(user.Username);
    };
    fetchUser();
  }, []);

  const getCertificates = useCallback(async () => {
    if (!currentUser) return; // attendi che currentUser sia valorizzato
    const res = await (await fetch(`${ServerConfig.AWS.Serverless.API_BASE_URL_1}/teachers/${currentUser}`)).json();
    setCertificates(Array.isArray(res) ? res : []);
    setLoading(false);
  }, [currentUser]);

  const fetchCourses = useCallback(async () => {
    const res = await (await fetch(`${ServerConfig.AWS.Serverless.API_BASE_URL_1}/certificates`)).json();
    setCourses(Array.isArray(res) ? res : []);
  }, []);

  const assignCourseToTeacher = useCallback(async (course, teacher) => {
    await fetch(`${ServerConfig.AWS.Serverless.API_BASE_URL_1}/courses/assign/${teacher}`, {
      method: "PUT",
      body: JSON.stringify({ course, teachers: certificates }),
      headers: { "Content-Type": "application/json" }
    });
    getCertificates();
  }, [certificates, getCertificates]);

  const handleCreate = useCallback(() => {
    setDrawerTitle("Crea Docente");
    setDrawerContent(
      <TeacherForm 
        assigned={currentUser} 
        onSubmit={getCertificates} 
        onClose={() => setDrawerOpen(false)} 
      />
    );
    setDrawerOpen(true);
  }, [currentUser, getCertificates]);

  const handleEdit = useCallback((teacher) => {
    setDrawerTitle("Modifica Docente");
    setDrawerContent(
      <TeacherForm 
        initialData={teacher} 
        assigned={currentUser || teacher.assigned} 
        onSubmit={getCertificates} 
        onClose={() => setDrawerOpen(false)} 
      />
    );
    setDrawerOpen(true);
  }, [currentUser, getCertificates]);

  useEffect(() => {
    if (currentUser) {
      getCertificates();
      fetchCourses();
    }
  }, [currentUser, getCertificates, fetchCourses]);

  return (
    <>
      {loading && <ListSkeleton />}
      {!loading && (
        <swiper-container slides-per-view="3" ref={swiperRef} virtual="true" navigation="true" style={{ paddingBottom: 320 }}>
          {courses.map((course) => (
            <swiper-slide key={course.id}>
              <SingleCourse
                course={course}
                certificates={certificates}
                assignCourseToTeacher={assignCourseToTeacher}
                refreshTeachers={getCertificates}
                onEdit={handleEdit}
              />
            </swiper-slide>
          ))}
        </swiper-container>
      )}

      <Drawer anchor="right" open={drawerOpen} onClose={() => setDrawerOpen(false)}>
        <Box sx={{ width: 600, height: "100vh", display: "flex", flexDirection: "column" }}>
          <Box
            sx={{
              background: 'linear-gradient(to bottom right, #9DCEE2, #7256CB)',
              color: "#fff",
              height: "80px",
              display: "flex",
              alignItems: "center",
              px: 2
            }}
          >
            <Typography variant="h6">{drawerTitle}</Typography>
          </Box>
          <Box sx={{ flex: 1, overflowY: "auto", bgcolor: "#fafafa" }}>
            {drawerContent}
          </Box>
        </Box>
      </Drawer>

      <FloatingActionButtons onClick={handleCreate} />
    </>
  );
};

export default ListTeachers;


